import { AppID } from '@playq/octopus-common';

export const getEnabledOrPrefetchStatus = (optionsEnabled: boolean | undefined, appID: AppID | undefined): boolean => {
  return (optionsEnabled ?? true) && appID !== undefined;
};
